module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Volumes/Data/projecten/uw-schilderwerk-website/node_modules/core-js/modules/_iterators.js
// module id = 19
// module chunks = 11